import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Item = styled.div`
    flex: 0 0 100%;
    position: relative;
    margin-bottom: 16px;
    img{
        width: 100%;
    }
    @media (min-width: 768px) {
		flex: 0 0 calc(50% - 8px);
	}
    @media (min-width: 992px) {
		flex: 0 0 calc(33% - 8px);
	}
    @media (min-width: 1200px) {
		flex: 0 0 calc(33% - 8px);
	}
`;

const RouteTo = styled.a`
`;

const TopBar = styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    background: rgba(0, 59, 122, 0.93);
    width: calc(100% - 16px);
    padding: 8px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
`;

const Service = styled.h2`
    display: inline;
    margin: 0;
    font-size: 22px;
    font-family: "Nunito";
    font-weight: 300;
    color: #fff;
`;

const Grid = ({Heading, Image, href}) => (
    
        <Item>
            <RouteTo href={href}>
            <TopBar><Service>{Heading}</Service></TopBar>
            <img src={Image} />
            </RouteTo>
        </Item>
);

export default Grid;


// WEBPACK FOOTER //
// ./src/components/grid/item.js